"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
/* export default function combine(arr: any[], n: number) {
    const combinations: any[] = [];
    function f(combination: any[], index) {
        if (combination.length < n) {
            find(
                arr,
                (value, i) => {
                    f(concat(combination, [value]), i + 1);
                },
                index
            );
        } else {
            combinations.push(combination);
        }
    }
    f([], 0);
    return combinations;
} */
function combine(arr, n) {
    var combinations = [];
    if (arr.length < n)
        return [];
    if (n === arr.length)
        return [arr];
    if (n === 1)
        return arr.map(function (value) { return [value]; });
    lodash_1.forEach(arr, function (value, i) {
        var newArray = arr.slice(i + 1);
        var nextCombs = combine(newArray, n - 1);
        nextCombs.forEach(function (c) { return combinations.push(lodash_1.concat(value, c)); });
    });
    return combinations;
}
exports.default = combine;
//# sourceMappingURL=combine.js.map